import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';
import { DataTableBodyCellComponent } from '@swimlane/ngx-datatable';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
    selector: 'IngresoRecursosParcial',
	templateUrl: './IngresoRecursosParcial.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Michael
* @since  22/04/2019
**/
export class IngresoRecursosParcial {

	public form: FormGroup;
	public formErrors: any;

    public nvalorDistribuir: number;
    public nbaseOrigen: string;
    public fechaIndenmizacion:Date;

    public fechaUltimoCierre:Date;
    public fechaMesSiguienteUltimoCierre:Date;
    public fechaParametros:Date;
    
    public ocultar: boolean = false;
	public mensaje: string = "";
    
	public guardando: boolean = true;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

            this.formErrors = {
                nbaseOrigen: {},
                nvalorDistribuir: {},
                fechaIndenmizacion:{}
            };

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.snackBar.dismiss();
	}


    ngOnInit() {
        this.inicializarFormulario();
    }

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


    inicializarFormulario() {
        
        this._serviciosGenerales.get('fechaUltimoCierreVictimas', {}).subscribe(
            result => {

                for (var x of result) {
                    this.fechaUltimoCierre = new Date(x.fecha);
                }
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });

            
        this._serviciosGenerales.get('fechaMesSiguienteUltimoCierre', {}).subscribe(
            result => {

                for (var x of result) {
                    this.fechaMesSiguienteUltimoCierre = new Date(x.fecha);
                }
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });

		this.form = this.formBuilder.group({
            nbaseOrigen: ['', Validators.required],
            nvalorDistribuir: ['', Validators.required],
            fechaIndenmizacion: ['', Validators.required],
		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
    }

    
    distribuirBase(){

        this.guardando = false;

        if(this.fechaParametros <= this.fechaUltimoCierre){
            this.openSnackBarEspecial('No se puede realizar el proceso de Distribución Recursos Parciales con los datos ingresados porque la fecha del ultimo cierre es mayor o porque el mes ya se encuentra cerrado.', 'X');
            this.guardando = true;
            return;
        }

        if(this.fechaParametros >= this.fechaMesSiguienteUltimoCierre){
            this.openSnackBarEspecial('No se puede realizar el proceso de Distribución Recursos Parciales con los datos ingresados porque el mes es superior ó igual 2 meses al ultimo cierre', 'X');
            this.guardando = true;
            return;
        }
        
        let parametros = {
                           NBASE : this.nbaseOrigen.toString(),
                           NVALOR_INDENMIZACION : this.nvalorDistribuir.toString(),
                           FECHA: new Date(this.fechaIndenmizacion),
                           VUSUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario
                        };

                   console.log("JOvennnnnnnnn ",new Date(this.fechaIndenmizacion).toISOString().substr(0, 10));     

        this._serviciosGenerales.get('procedure/PRC_DISTRIBUIR_VALOR_BASE', parametros).subscribe(
            result => {
                console.log(result);

                if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
                    this.openSnackBarEspecial(result.mensaje, "X");
                    this.guardando = true;
                    return;
                } else {
                    this.form.reset();
                    this.form.clearAsyncValidators();
                    this.form.clearValidators();
                    this.inicializarFormulario();
                    this.openSnackBar('Distribución recuros Parciales correctamente: '+result.mensaje.replace('OK',''), "X");
                }
                this.guardando = true;
            }, error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
                this.guardando = true;
            })
    }

    openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
    

    bloquearBoton(){
		var count = 1;
		this.distribuirBase();
	}
    

}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/IngresoRecursosParcial/IngresoRecursosParcial.component.ts